import React from 'react'
import { useAppParamsContext } from '../context/AppParamsContext'

/**
 * Hàm khởi tạo Component Icon tự động thay đổi theo theme.
 * 
 * @param {Object} icons - Một object chứa các icon tương ứng với theme. 
 *                         BẮT BUỢC phải truyền một icon vào key `default`.
 *                         Ví dụ: { default: IconThuong, BIDV: IconBIDV }
 * @returns {React.FC} Component tự động chọn icon.
 */
export const createThemeIcon = (icons) => {
  return (props) => {
    const { appThemeName } = useAppParamsContext()
    const currentTheme = String(appThemeName || '').toUpperCase()
    const TargetIcon = icons[currentTheme] || icons.default || icons['DEFAULT']

    if (!TargetIcon) {
      console.warn('createThemeIcon: Bạn quên truyền icon mặc định (key `default`)')
      return null
    }

    return <TargetIcon {...props} />
  }
}
